// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AccountTermsModel } from "@store/Framework/Services/AccountService";
import StoreAccountState from "@store/Framework/Store/Store/Data/Accounts/AccountState";
import { Draft } from "immer";

const initialState: StoreAccountState = {
    isLoading: false,
    isLoadingPriceList: false,
    currentAccountId: "",
    currentTermsUrl: "",
    nextTermsUrl: "",
};

const actions = {
    "Store/Data/Accounts/BeginLoadAccount": (draft: Draft<StoreAccountState>, action: {}) => {
        draft.isLoading = true;
    },
    "Store/Data/Accounts/CompleteLoadAccountTerms": (
        draft: Draft<StoreAccountState>,
        action: {
            model: AccountTermsModel;
            currentAccountId: string;
        },
    ) => {
        draft.isLoading = false;
        draft.currentAccountId = action.currentAccountId;
        draft.currentTermsUrl = action.model.currentTermsUrl || "";
        draft.nextTermsUrl = action.model.nextTermsUrl || "";
    },
    "Store/Data/Accounts/BeginLoadPriceList": (draft: Draft<StoreAccountState>, action: {}) => {
        draft.isLoadingPriceList = true;
    },
    "Store/Data/Accounts/CompleteLoadPriceList": (draft: Draft<StoreAccountState>, action: {}) => {
        draft.isLoadingPriceList = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreAccountActions = Parameters<typeof reducer>[1];
export default reducer;
